<script>
//
export let pageCopy;
export let pageTitle;
let theTitle;
// export let buttonText;
// export let buttonLink;
// export let imgLoc;
if(pageTitle!== null){
	theTitle=pageTitle;

}else{
	theTitle="";
}
//
// console.log("pageCopy =",pageCopy);
</script>
<section>
    <div class="fic--intro-text">
        

        {#if theTitle !== ""}
			<h1>{@html theTitle}</h1>
    	{/if }

        {@html pageCopy}
    </div>
</section>